/* 
* This file is auto-generated by Graphweaver. 
* Please do not edit it directly.
*/
import * as Types from '../../../../../backend/src/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FirstTimeMigratedUserFetchUserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type FirstTimeMigratedUserFetchUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, hasLoggedIn?: boolean | null, migrationAccountUuid?: string | null } | null };

export type FirstTimeMigratedUserUpdateUserMutationVariables = Types.Exact<{
  input: Types.UserUpdateInput;
}>;


export type FirstTimeMigratedUserUpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'User', id: string, hasLoggedIn?: boolean | null } | null };


export const FirstTimeMigratedUserFetchUserDocument = gql`
    query FirstTimeMigratedUserFetchUser {
  currentUser {
    id
    hasLoggedIn
    migrationAccountUuid
  }
}
    `;

/**
 * __useFirstTimeMigratedUserFetchUserQuery__
 *
 * To run a query within a React component, call `useFirstTimeMigratedUserFetchUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useFirstTimeMigratedUserFetchUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFirstTimeMigratedUserFetchUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useFirstTimeMigratedUserFetchUserQuery(baseOptions?: Apollo.QueryHookOptions<FirstTimeMigratedUserFetchUserQuery, FirstTimeMigratedUserFetchUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FirstTimeMigratedUserFetchUserQuery, FirstTimeMigratedUserFetchUserQueryVariables>(FirstTimeMigratedUserFetchUserDocument, options);
      }
export function useFirstTimeMigratedUserFetchUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FirstTimeMigratedUserFetchUserQuery, FirstTimeMigratedUserFetchUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FirstTimeMigratedUserFetchUserQuery, FirstTimeMigratedUserFetchUserQueryVariables>(FirstTimeMigratedUserFetchUserDocument, options);
        }
export function useFirstTimeMigratedUserFetchUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FirstTimeMigratedUserFetchUserQuery, FirstTimeMigratedUserFetchUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FirstTimeMigratedUserFetchUserQuery, FirstTimeMigratedUserFetchUserQueryVariables>(FirstTimeMigratedUserFetchUserDocument, options);
        }
export type FirstTimeMigratedUserFetchUserQueryHookResult = ReturnType<typeof useFirstTimeMigratedUserFetchUserQuery>;
export type FirstTimeMigratedUserFetchUserLazyQueryHookResult = ReturnType<typeof useFirstTimeMigratedUserFetchUserLazyQuery>;
export type FirstTimeMigratedUserFetchUserSuspenseQueryHookResult = ReturnType<typeof useFirstTimeMigratedUserFetchUserSuspenseQuery>;
export type FirstTimeMigratedUserFetchUserQueryResult = Apollo.QueryResult<FirstTimeMigratedUserFetchUserQuery, FirstTimeMigratedUserFetchUserQueryVariables>;
export const FirstTimeMigratedUserUpdateUserDocument = gql`
    mutation FirstTimeMigratedUserUpdateUser($input: UserUpdateInput!) {
  updateUser(input: $input) {
    id
    hasLoggedIn
  }
}
    `;
export type FirstTimeMigratedUserUpdateUserMutationFn = Apollo.MutationFunction<FirstTimeMigratedUserUpdateUserMutation, FirstTimeMigratedUserUpdateUserMutationVariables>;

/**
 * __useFirstTimeMigratedUserUpdateUserMutation__
 *
 * To run a mutation, you first call `useFirstTimeMigratedUserUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFirstTimeMigratedUserUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [firstTimeMigratedUserUpdateUserMutation, { data, loading, error }] = useFirstTimeMigratedUserUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFirstTimeMigratedUserUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<FirstTimeMigratedUserUpdateUserMutation, FirstTimeMigratedUserUpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FirstTimeMigratedUserUpdateUserMutation, FirstTimeMigratedUserUpdateUserMutationVariables>(FirstTimeMigratedUserUpdateUserDocument, options);
      }
export type FirstTimeMigratedUserUpdateUserMutationHookResult = ReturnType<typeof useFirstTimeMigratedUserUpdateUserMutation>;
export type FirstTimeMigratedUserUpdateUserMutationResult = Apollo.MutationResult<FirstTimeMigratedUserUpdateUserMutation>;
export type FirstTimeMigratedUserUpdateUserMutationOptions = Apollo.BaseMutationOptions<FirstTimeMigratedUserUpdateUserMutation, FirstTimeMigratedUserUpdateUserMutationVariables>;